import React from 'react';

import img1 from '../../assets/imgs/us-img1.png';

import './index.scss';

export default function Us() {
    return (
        <div id="us-pc" className="px-[8.3vw] mb-[24px]">
            <div className="text-[#333] mt-[24px]">
                <h1 className="text-[24px] font-medium text-center">
                    关于我们
                </h1>
                <p className="text-[14px] mt-[24px]">
                    四川光启卓瑞科技有限公司是一家专注于互联网产品研发与运营的创新型科技企业，旗下拥有好运吧、光启学词、晴风预报等多款隐私保护类应用。我们会使用安全的技术，
                    保障您的信息、隐私安全。我们将秉持需求为先的理念，为用户提供人性化的服务。
                </p>
            </div>

            <div className="text-[#333] flex flex-col items-center mt-[24px]">
                <h1 className="text-[24px] font-medium">联系我们</h1>

                <div className="mt-[24px] relative">
                    <img
                        className="w-[1020px] h-[300px]"
                        src={img1}
                        alt="地址"
                    />
                    <div
                        className="
                          tips-container
                          absolute
                          top-0 p-[12px]
                          left-[15%]
                          max-w-[340px]
                          min-w-[180px]
                          h-[250px]
                          bg-[#4371ff]
                          opacity-80
                          text-[#fff]
                          text-[10px]"
                    >
                        <h1 className="text-[18px]">
                            四川光启卓瑞科技有限公司
                        </h1>
                        <p>
                            地址：四川省绵阳市科技城新区创新中心2号楼B218-557室
                        </p>
                        <p>邮编：621050</p>
                        <p>
                            广告合作及违规广告投诉举报反馈邮箱：17361295293@163.com
                        </p>
                        <p>工作时间：周一至周五：09:00-18:00</p>
                        <p>中国互联网举报中心：12377</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
